// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.hospital-info-banner[data-v-96ac6bfe] {\n  width: calc(100% - 30px);\n  margin: 15px auto 0;\n}\n@media (max-width: 767px) {\n.hospital-info-banner[data-v-96ac6bfe] {\n    width: 100%;\n}\n}\n", ""]);
// Exports
module.exports = exports;
